module.exports = __webpack_public_path__ + "img/preview_display.4d86db6a.jpg";